<template>
  <aside
    :class="[
      'main-sidebar',
      'col-12',
      'col-md-3',
      'col-xl-2',
      'px-0',
      showSidebar ? 'open' : '',
    ]"
  >
    <!-- <div class="main-navbar">
      <nav class="navbar align-items-stretch navbar-light bg-white flex-md-nowrap p-0">
        <a class="toggle-sidebar d-sm-inline d-md-none d-lg-none" @click="handleToggleSidebar()">
          <i class="material-icons">&#xE5C4;</i>
        </a>
      </nav>
    </div> -->

    <div class="nav-wrapper">
      <d-nav class="flex-column nav-group">
        <li
          v-for="(item, navItemIdx) in items"
          :key="navItemIdx"
        >
          <div class="nav-item">

            <d-link
              v-if="!item.dev || (item.dev && dev)"
              :class="['nav-link']"
              :to="item.to"
            >
              <div
                class="item-icon-wrapper"
                v-if="item.htmlBefore"
                v-html="item.htmlBefore"
              />
              <span v-if="item.title">{{ item.title }}</span>
              <div
                class="item-icon-wrapper"
                v-if="item.htmlAfter"
                v-html="item.htmlAfter"
              />
            </d-link>
          </div>
          <ul class="list-unstyled pl-4" v-if="$route.meta.group === item.to.name">
            <li v-for="(subItem, subItemIdx) in item.pages" :key="subItemIdx">
              <d-link :to="subItem.to" class="text-light">
                {{ subItem.title }}
              </d-link>
            </li>
          </ul>
        </li>
      </d-nav>
    </div>
  </aside>
</template>

<script>
import { __DEV__ } from "@/helpers";

export default {
  name: "main-sidebar",
  props: {
    /**
     * Whether to hide the logo text, or not.
     */
    hideLogoText: {
      type: Boolean,
      default: false,
    },
    /**
     * The menu items.
     */
    items: {
      type: Array,
      required: true,
    },
    showSidebar: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      dev: __DEV__,
      showSubpages: "",
    };
  },
};
</script>

<style lang="scss">
.main-sidebar {
  z-index: 15;

  .item-icon-wrapper {
    display: inline-block;
  }
  .dropdown-menu {
    display: block;
  }

  .dash-title {
    font-size: 2rem;
    font-weight: 700;
    width: 100%;
  }
}
</style>
